import { APIHelper } from '@archistarai/auth-frontend';

export default {
  namespaced: true,
  state: {
    countries: [],
    currentCountryCode: null
  },
  getters: {
    whereCountryName(state) {
      return (name) => state.countries.find((c) => c.name === name);
    }
  },
  mutations: {
    ADD_COUNTRIES(state, countries) {
      state.countries = countries;
    },
    ADD_CURRENT_COUNTRY_CODE(state, currentCountryCode) {
      state.currentCountryCode = currentCountryCode;
    }
  },
  actions: {
    async getCountries({ commit }) {
      try {
        const {
          data: { data: c }
        } = await APIHelper.AdminAPI.get('/countries');
        const countries = Object.keys(c).map((k) => ({
          name: c[k].name,
          currency: c[k].currency ? c[k].currency : '',
          country_code_2: k
        }));
        commit('ADD_COUNTRIES', countries);
        return countries;
      } catch (e) {
        throw e;
      }
    },
    getCurrentCountryCodeFromHeader({ commit }) {
      const req = new XMLHttpRequest();
      req.open('GET', document.location, false);
      req.send(null);
      let currentCountryCode = req.getResponseHeader('cloudfront-viewer-country') || null;
      commit('ADD_CURRENT_COUNTRY_CODE', currentCountryCode);
      return currentCountryCode;
    }
  }
};
